<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" id="echarts-dom" ref="echarts-bar"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    xData: {
      type: Array,
      default() {
        return [];
      }
    },
    yData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    yData() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let barHeght = this.$refs["echarts-bar"].clientHeight * 0.68;
      let $echartsDOM = document.getElementById("echarts-dom");
      let myEcharts = this.$echarts.init($echartsDOM);
      let radiusBarList
      if (this.yData.length>2) {
        radiusBarList = [0,this.yData[2].value,this.yData[1].value,this.yData[0].value]
      }else if (this.yData.length==1) {
        radiusBarList = [0,0,0,this.yData[0].value]
      }else{
        radiusBarList = [0,0,this.yData[1].value,this.yData[0].value]
      }
      let option = {
        grid: {
          top: "8%",
          left: "8%",
          right: "0",
          bottom: "10%",
          containLabel: false,
          height: barHeght
        },
        angleAxis: {
            axisLine:{
                show:false
            },
            axisTick:{
                show:false
            },
            splitLine:{
                show:false
            },
            axisLabel:{
                show:false
            },
            boundaryGap:['0','20%']
            
        },
        radiusAxis: {
            type: 'category',
            data: ['周一', '周二', '周三'],
            z: 10,
            axisLine:{
                show:false
            },
            axisTick:{
                show:false
            },
            splitLine:{
                show:false
            },
            axisLabel:{
                show:false
            }
        },
        polar: {
        },
        series: [{
            type: 'bar',
            data: radiusBarList,
            coordinateSystem: 'polar',
            name: 'A',
            stack: 'a',
            barWidth:10,
            itemStyle: {
              normal:{  
                color: function (params){
                    var colorList = ['','#F5A623','#4ACAA8','#698EFF'];
                    return colorList[params.dataIndex];
                }
              },
            }
        }]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_bar-radius/index.vue